import React from 'react';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';

import { RENTAL_ITEM  } from 'graphql/queries/rental-items';

import { RENTAL_ITEMS_PRICES_FORMS_NUMBERS } from 'pages/create-rental-items/constants';

import { getReceivedRentalItemsData  } from 'utils/rental-items/prepareReceivedRentalItemsData';


import ConfirmContext from 'contexts/ConfirmContext';



const UpdateRentalItemsWrapper = ({ children, businessOwner }) => {
  const { id } = useParams();
  const confirm = React.useContext(ConfirmContext);
  const history = useHistory();

  const { loading, error, data, refetch, networkStatus } = useQuery(
    RENTAL_ITEM,
    {
      variables: {
        rentalItemsId: id,
        businessOwnerId:
          businessOwner.selectedBusinessOwner.ownerId ||
          businessOwner.selectedBusinessOwner.id
      },
      notifyOnNetworkStatusChange: true
    }
  );


  React.useEffect(() => {
    refetch();
  }, []);

  

  if (
    loading ||
    networkStatus === 4 
  ) {
    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: true,

        })}
      </div>
    );
  }

  if (error || !data.rentalItems.length) {
    if (
      businessOwner &&
      businessOwner.selectedBusinessOwner.hasOwnProperty('id')
    ) {
      confirm({
        title: 'Rental Items does not exist!',
        confirmationText: 'Back'
      })
        .then(() => history.push('/accommodations-and-activities'))
        .catch(() => {});
    }

    return (
      <div style={{ height: '100%' }}>
        {React.cloneElement(children, {
          loading: false,
          
        })}
      </div>
    );
  }

  const rentalItem = data.rentalItems[0];
  
  const initialData = getReceivedRentalItemsData(rentalItem);
  let pricesActiveSubTabNumber; 
  if (rentalItem.prices[0] && rentalItem.prices[0]?.type === "FIXED") {
  pricesActiveSubTabNumber = RENTAL_ITEMS_PRICES_FORMS_NUMBERS.pricesFixedForm;
}
  
  if (rentalItem.prices[0]?.day && rentalItem.prices[0]?.type === "DAY") {
  pricesActiveSubTabNumber = RENTAL_ITEMS_PRICES_FORMS_NUMBERS.pricesDailyForm;
}

if (rentalItem.prices[0]?.day && rentalItem.prices[0]?.type === "WEEKDAY") {
  pricesActiveSubTabNumber = RENTAL_ITEMS_PRICES_FORMS_NUMBERS.pricesWeeklyForm;
}

if (rentalItem.hourlyPrices[0]) {
  pricesActiveSubTabNumber = RENTAL_ITEMS_PRICES_FORMS_NUMBERS.pricesHourlyForm;
}


  

  return (
    <div style={{ height: '100%' }}>
      {React.cloneElement(children, {
        data: initialData,
        pricesActiveSubTabNumber,
        loading: false,

      })}
    </div>
  );
};

const mapStateToProps = state => ({
  businessOwner: state.businessOwner
});

export default connect(mapStateToProps, null)(UpdateRentalItemsWrapper);
